import { Bell } from "lucide-react";

const manifest = {
  key: "notifications_management",
  isFreeModule: true,
  isPurchasable: false,
  icon: Bell,
  names: {
    plan: { en: "Notifications", ar: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062a" },
    dashboard: {
      en: "Notifications",
      ar: "\u0627\u0644\u0625\u0634\u0639\u0627\u0631\u0627\u062a",
    },
  },
  defaultPath: "/notifications",
  matchers: [/^\/notifications(?:\/|$)/],
  buildNavbarMenus: ({ activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "/notifications",
    },
  ],
};

export default manifest;

